import { render, staticRenderFns } from "./UserProfileSelection.vue?vue&type=template&id=4adc169d&scoped=true&"
import script from "./UserProfileSelection.vue?vue&type=script&lang=js&"
export * from "./UserProfileSelection.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileSelection.vue?vue&type=style&index=0&id=4adc169d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc169d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VList,VListItem})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adc169d')) {
      api.createRecord('4adc169d', component.options)
    } else {
      api.reload('4adc169d', component.options)
    }
    module.hot.accept("./UserProfileSelection.vue?vue&type=template&id=4adc169d&scoped=true&", function () {
      api.rerender('4adc169d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/UserProfileSelection.vue"
export default component.exports